import React from 'react';
import '../Css/App.css';
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";

export function Header() {
    const navigate = useNavigate();

    return (
        <header className="about-header">
            <div className="about-header-content">
                <div className="about-logo-wrapper">
                    <Button onClick={() => navigate("/")}>
                        <span className="header-logo" role="img" aria-label="Smart Task Software logo">
                            <span className="header-logo-inner">
                                <img className="header-logo-c" src="/images/smart-task-software-logo/logo-update-2026/sts-logo-c.png" alt=""/>
                                <img className="header-logo-hex" src="/images/smart-task-software-logo/logo-update-2026/sts-logo-hex.png" alt=""/>
                            </span>
                        </span>
                        <h1>Smart Task Software</h1>
                    </Button>
                </div>
                <div className="about-nav-wrapper">
                        <Button size="large" onClick={() => navigate("/about")}>Our Team</Button>
                        <Button size="large" onClick={() => navigate("/projects")}>Projects</Button>
                        <Button size="large" onClick={() => navigate("/contact")}>Contact</Button>
                </div>
            </div>
        </header>
  );
}